import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col, Button, Collapse,
} from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import IconWithText from 'components/Widgets/IconWithText';
import { useContext as useUsersContext } from 'components/Users/Context';
import actions from 'components/Affiliates/Training/Actions';

import TrainingStepDocument from './TrainingStepDocument';
import TrainingStatus from './TrainingStatus';

export default function TrainingStep({ trainingStep, index }) {
  const { state: stateUsers, dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(index === 0);

  const affiliate = stateUsers.user.attributes.specific;
  const affiliateTraining = affiliate.training_steps.find(
    (training) => training.step_id === trainingStep.id,
  ) || {};

  const refreshAffiliate = () => {
    actionsUsers.load(
      dispatchUsers,
      () => setLoading(false),
    );
  };

  const markCompleted = () => {
    setLoading(true);

    actions.markTrainingStepCompleted(
      trainingStep.id,
      () => refreshAffiliate(),
    );
  };

  const counterBackground = affiliateTraining.status === 'Completed' ? 'bg-primary-counter' : 'bg-secondary-counter';

  return (
    <li className={`d-flex mb-5 ${counterBackground}`}>
      <div className="flex-grow-1">
        <Row className="align-items-center" style={{ minHeight: '4rem' }}>
          <Col>
            <Button
              variant="link"
              className="fs-4 text-decoration-none text-gray-900 fw-semibold"
              onClick={() => setOpen(!open)}
              aria-controls={`step-${trainingStep.id}-collapse`}
              aria-expanded={open}
            >
              {trainingStep.attributes.title}
            </Button>

            <TrainingStatus affiliateTraining={affiliateTraining} />
          </Col>

          <Col xs="auto">
            <Button
              variant="light"
              className="btn-reverse d-none d-lg-inline-block"
              onClick={markCompleted}
              disabled={loading || (affiliateTraining.status === 'Completed')}
            >
              {loading && <LoadingPlaceholder placement="inline" text=" " />}
              Mark Completed
            </Button>

            <Button
              variant="light"
              className="ms-3 p-0"
              style={{ borderRadius: '50%', borderBottomLeftRadius: '0' }}
              onClick={() => setOpen(!open)}
              aria-controls={`step-${trainingStep.id}-collapse`}
              aria-expanded={open}
            >
              <IconWithText
                iconClassName="chevron-icon small-icon"
                wrapperClassName="p-2"
              />
            </Button>
          </Col>
        </Row>

        <Collapse in={open}>
          <div id={`step-${trainingStep.id}-collapse`} className="ms-n3">
            <div className="d-block d-lg-none mb-2 text-end">
              <Button
                variant="light"
                className="btn-reverse d-block w-100"
                onClick={markCompleted}
                disabled={loading || (affiliateTraining.status === 'Completed')}
              >
                {loading && <LoadingPlaceholder placement="inline" text=" " />}
                Mark Completed
              </Button>
            </div>

            <div className="p-3 border border-2 rounded-3">
              <p className="text-gray-800">
                {trainingStep.attributes.description}
              </p>

              {trainingStep.attributes.documents.length > 0 && (
                <Row md={2} lg={3}>
                  {trainingStep.attributes.documents.map(
                    (item) => <TrainingStepDocument key={item.id} record={item} />,
                  )}
                </Row>
              )}
            </div>
          </div>
        </Collapse>
      </div>
    </li>
  );
}

TrainingStep.propTypes = {
  trainingStep: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};
